/**
 * PhoneSwap — Morgan Legal Group
 * Visually cycles the phone display between the numeric form and the vanity
 * form (888-529-1315 ↔ 888-LAW-1315) with a short fade, matching the effect on
 * morganlegalny.com. "LAW" = 5-2-9 on the keypad, so the underlying tel: link
 * (888-529-1315) is unchanged; this is purely a display flourish.
 */
import { useEffect, useState } from 'react';

const VARIANTS = ['888-529-1315', '888-LAW-1315'];

// Render the vanity variant with the "LAW" letters in white; everything else
// inherits the parent (gold) color.
function renderVariant(v: string) {
  if (v.includes('LAW')) {
    return (
      <>
        888-<span className="text-white">LAW</span>-1315
      </>
    );
  }
  return v;
}

interface PhoneSwapProps {
  className?: string;
  intervalMs?: number;
}

export default function PhoneSwap({ className = '', intervalMs = 3000 }: PhoneSwapProps) {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((prev) => (prev + 1) % VARIANTS.length), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);

  // Both variants are rendered stacked in the SAME grid cell, so the element
  // always reserves the width of the wider variant — the neighbouring
  // "Schedule Your Consultation" button never shifts when the text swaps.
  return (
    <span className={`inline-grid whitespace-nowrap tabular-nums ${className}`} aria-label="888-529-1315">
      {VARIANTS.map((v, idx) => (
        <span
          key={idx}
          aria-hidden={idx !== i}
          className={`col-start-1 row-start-1 inline-block transition-opacity duration-300 ${
            idx === i ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {renderVariant(v)}
        </span>
      ))}
    </span>
  );
}
